var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShape25(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L22 0L22 22L0 22L0 0Z",
    id: "path_1"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "mask_1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path_1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vision"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L22 0L22 22L0 22L0 0Z",
    id: "Background",
    fill: "#FFFFFF",
    fillOpacity: 0,
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#mask_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.375 4.8125C1.7547 4.8125 2.0625 4.5047 2.0625 4.125L2.0625 2.0625L4.125 2.0625C4.50469 2.0625 4.8125 1.7547 4.8125 1.375C4.8125 0.995307 4.5047 0.687502 4.125 0.6875L1.375 0.6875C0.995304 0.6875 0.6875 0.995304 0.6875 1.375L0.6875 4.125C0.6875 4.5047 0.995304 4.8125 1.375 4.8125L1.375 4.8125Z",
    id: "Shape",
    fill: "#10B48C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.875 2.0625L19.9375 2.0625L19.9375 4.125C19.9375 4.50469 20.2453 4.8125 20.625 4.8125C21.0047 4.8125 21.3125 4.5047 21.3125 4.125L21.3125 1.375C21.3125 0.995304 21.0047 0.6875 20.625 0.6875L17.875 0.6875C17.4953 0.6875 17.1875 0.995303 17.1875 1.375C17.1875 1.75469 17.4953 2.0625 17.875 2.0625L17.875 2.0625Z",
    id: "Shape",
    fill: "#10B48C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.125 19.9375L2.0625 19.9375L2.0625 17.875C2.0625 17.4953 1.7547 17.1875 1.375 17.1875C0.995307 17.1875 0.687502 17.4953 0.6875 17.875L0.6875 20.625C0.6875 21.0047 0.995304 21.3125 1.375 21.3125L4.125 21.3125C4.50469 21.3125 4.8125 21.0047 4.8125 20.625C4.8125 20.2453 4.5047 19.9375 4.125 19.9375L4.125 19.9375Z",
    id: "Shape",
    fill: "#10B48C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.625 17.1875C20.2453 17.1875 19.9375 17.4953 19.9375 17.875L19.9375 19.9375L17.875 19.9375C17.4953 19.9375 17.1875 20.2453 17.1875 20.625C17.1875 21.0047 17.4953 21.3125 17.875 21.3125L20.625 21.3125C21.0047 21.3125 21.3125 21.0047 21.3125 20.625L21.3125 17.875C21.3125 17.4953 21.0047 17.1875 20.625 17.1875L20.625 17.1875Z",
    id: "Shape",
    fill: "#10B48C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.25 11C8.25 9.48122 9.48122 8.25 11 8.25C12.5188 8.25 13.75 9.48122 13.75 11C13.75 12.5188 12.5188 13.75 11 13.75C9.48122 13.75 8.25 12.5188 8.25 11Z",
    id: "Circle",
    fill: "#10B48C",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2368 11.3162C21.3396 11.1179 21.3396 10.8821 21.2368 10.6838C19.3197 6.75509 15.3703 4.22475 11 4.125C6.62961 4.22475 2.68027 6.75509 0.76309 10.6838C0.66035 10.8821 0.66035 11.1179 0.763091 11.3162C2.68027 15.2449 6.62961 17.7753 11 17.875C15.3703 17.7753 19.3197 15.2449 21.2368 11.3162L21.2368 11.3162ZM11 15.125C8.72183 15.125 6.875 13.2782 6.875 11C6.875 8.72183 8.72181 6.87501 11 6.875C13.2782 6.87499 15.125 8.72181 15.125 11C15.125 13.2782 13.2782 15.125 11 15.125L11 15.125Z",
    id: "Shape",
    fill: "#10B48C",
    fillRule: "evenodd",
    stroke: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape25);
export default __webpack_public_path__ + "static/media/shape25.a7849c2421ebcde961bc755df52ca5de.svg";
export { ForwardRef as ReactComponent };